var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import * as classnames from "classnames";
import Overlay from "../internal/Overlay";
import CloseButton from "../internal/CloseButton";
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.closeButton = function () {
            return _this.props.dismissible ? (React.createElement(CloseButton, { onClick: _this.handleClick, ariaLabel: _this.props.ariaLabel })) : null;
        };
        _this.handleClick = function () {
            if (_this.props.dismissible) {
                var onClose = _this.props.onClose;
                if (onClose)
                    onClose();
            }
        };
        return _this;
    }
    Modal.prototype.componentDidMount = function () {
        if (this.modal) {
            this.modal.focus();
        }
    };
    Modal.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, size = _a.size, show = _a.show;
        var modalClassNames = classnames("wds-modal", className, { "wds-modal--enter": show }, { "wds-modal--exit": !show }, "wds-modal--" + size);
        return (React.createElement("div", { className: modalClassNames },
            React.createElement(Overlay, { onClick: this.handleClick }),
            React.createElement("div", { role: "dialog", className: "wds-modal__modal", ref: function (modal) {
                    _this.modal = modal;
                }, tabIndex: -1 },
                this.closeButton(),
                this.props.children)));
    };
    return Modal;
}(React.Component));
Modal.defaultProps = {
    className: "",
    dismissible: true,
    onClose: null,
    show: false,
    size: "sm",
    ariaLabel: "Close Modal"
};
export default Modal;
//# sourceMappingURL=Modal.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/Modal/Modal.js
// module id = 1793
// module chunks = 17